module.exports = __webpack_public_path__ + "iMac.2d6a84f86d17.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/marketing/images/iMac.png
// module id = ./src/app/marketing/images/iMac.png
// module chunks = 21